import React from "react"
import styled from "styled-components"
import { rem } from "polished"
import { media } from "@sr/common"

export interface ProductEntryDisclaimerProps {
  disclaimer: string
}

const ProductEntryDisclaimer = ({
  disclaimer,
}: ProductEntryDisclaimerProps) => {
  return (
    <ProductEntryDisclaimerStyled>{disclaimer}</ProductEntryDisclaimerStyled>
  )
}

export default ProductEntryDisclaimer

const ProductEntryDisclaimerStyled = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${rem(40)};
  max-width: ${rem(343)};
  font-size: ${rem(12)};
  line-height: ${rem(16)};
  font-weight: 400;
  font-style: italic;
  text-align: center;

  @media ${media.midUp} {
    max-width: ${rem(517)};
    padding-top: ${rem(48)};
  }
`
